var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-layout",
    [
      _c(
        "md-empty-state",
        {
          staticClass: "md-accent",
          attrs: {
            "md-rounded": "true",
            "md-icon": "warning",
            "md-label": "You are lost.",
            "md-description": "This page doesn't exist."
          }
        },
        [
          _c("md-button", { staticClass: "md-primary", attrs: { to: "/" } }, [
            _vm._v("Take me home.")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bfb8292", { render: render, staticRenderFns: staticRenderFns })
  }
}